import { useState } from 'react';

interface PreviewState {
  isOpen: boolean;
  documentUrl: string;
  documentName: string;
  documentType: 'simple' | 'generated' | 'signed';
  documentId?: number;
}

export const useDocumentPreview = () => {
  const [previewState, setPreviewState] = useState<PreviewState>({
    isOpen: false,
    documentUrl: '',
    documentName: '',
    documentType: 'simple',
    documentId: undefined,
  });

  const openPreview = (
    url: string,
    name: string,
    type: 'simple' | 'generated' | 'signed' = 'simple',
    id?: number
  ) => {
    setPreviewState({
      isOpen: true,
      documentUrl: url,
      documentName: name,
      documentType: type,
      documentId: id,
    });
  };

  const closePreview = () => {
    setPreviewState({
      isOpen: false,
      documentUrl: '',
      documentName: '',
      documentType: 'simple',
      documentId: undefined,
    });
  };

  return {
    previewState,
    openPreview,
    closePreview,
  };
};
